import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export default class QuickNav {
	constructor(container) {
		this.container = container;
		this.quickNav = this.container.querySelector('[data-menu-container]');
		this.sections = this.container.querySelectorAll('[data-section]');
		this.navItems = this.container.querySelectorAll('[data-quick-nav-link]');
		this.navTitles = this.container.querySelectorAll('[data-nav-title]');

		if(!this.quickNav) {
			return;
		}

		const scrollArea = this.container.querySelector('[data-content]');

		if (!scrollArea) {
			return;
		}

		this.createNavScrollTrigger(scrollArea);

		document.addEventListener('scroll', this.checkScrollPosition.bind(this));
		this.checkScrollPosition();
		this.setupScrollTo();
	}

	createNavScrollTrigger(trigger) {
		const mm = gsap.matchMedia();

		mm.add('(min-width: 992px)', () => {
			ScrollTrigger.create({
				trigger: trigger,
				start: '40px',
				end: `bottom top+=${this.quickNav.offsetHeight + 200}px`,
				pin: this.quickNav,
				pinSpacing: false,
			});
		});
	}

	checkScrollPosition() {
		if (!window.matchMedia('(min-width:768px)').matches) {
			return;
		}

		const check = window.scrollY + 185;

		let lastIndex = -1;

		this.sections.forEach((section, index) => {
			const rect = section.getBoundingClientRect();

			if (
				check >= rect.top + document.documentElement.scrollTop &&
				check <= rect.bottom + 185 + document.documentElement.scrollTop
			) {
				lastIndex = index;
			}
		});

		this.navItems.forEach((item, index) => {
			if (index === lastIndex) {
				item.classList.add('is-active');
			} else {
				item.classList.remove('is-active');
			}
		});
	}

	setupScrollTo() {
        this.navItems.forEach((item, index) => {
            item.addEventListener('click', () => {
                const targetMarker = this.navTitles[index];
                const targetPosition = targetMarker.getBoundingClientRect().top + window.scrollY;
                gsap.to(window, {
                    duration: 1,
                    scrollTo: {
                        y: targetPosition,
                        offsetY: 10,
                    },
                    ease: 'power3.inOut',
                });
            });
        });
    }
}